module.exports = __webpack_public_path__ + "img/error.09b99307.svg";